import api from '../api';

export const getAppVersions = () => () =>
  api.appVersion
    .getAppVersionsApi()
    .then((res) => res)
    .catch((err) => console.log(err));
